module.exports = __webpack_public_path__ + "img/pratices@2x.715f8017.png";